import React from 'react';
import { SpacingBox, EmptyState, EmptyIcon } from '../../Components';
import { PrimaryNewOrderButton } from './PrimaryNewOrderButton';
import { translate } from './translate';

export const EmptyStateForOrdersList = () => (
  <SpacingBox marginTop="xl">
    <EmptyState
      TopComponent={<EmptyIcon size="xl" />}
      BottomComponent={<PrimaryNewOrderButton />}
      title={translate('noOrders.title')}
      description={translate('noOrders.description')}
    />
  </SpacingBox>
);

export default EmptyStateForOrdersList;
